import { render, staticRenderFns } from "./SeguimientoTab.vue?vue&type=template&id=c6ae5bf8&scoped=true&lang=pug"
import script from "./SeguimientoTab.vue?vue&type=script&lang=js"
export * from "./SeguimientoTab.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoTab.vue?vue&type=style&index=0&id=c6ae5bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ae5bf8",
  null
  
)

export default component.exports